import { h, Component } from 'preact'
import { Option } from '../../UI/Option'
import s from './CountryOption.css'

interface iProps {
  value: string
  label: string
  flag: string
  code: number
}

class CountryOption extends Component<iProps> {
  render () {
    const {
      value,
      label,
      flag,
      code,
      ...props
    } = this.props

    return (
      <Option
        value={value}
        label={label}
        {...props}
      >
        <span className={s.CountryOption}>
          <span className={s.CountryOption__name}>
            <span className={s.CountryOption__flag}>
              {flag}
            </span>

            <span className={s.CountryOption__name}>
              {label}
            </span>
          </span>

          <span className={s.CountryOption__code}>
            +{code}
          </span>
        </span>
      </Option>
    )
  }
}

export default CountryOption
